//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "DiagnosticCriteriaForNMO",
  data() {
    return {
      form: {
        opticNeuritis:'0',
        acuteMyelitis:'0',
        headMri: "0",
        spinalCordMri: "0",
        serumNmo:'0'
      },
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        if(form.opticNeuritis && form.acuteMyelitis) {
          if(result <=3 ) {
          self.result = '不能诊断为NMO'
          } else {
          self.result = 'NMO'
          }
        } else {
          self.result = '不能诊断为NMO'
        }
     
        return self.result;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DiagnosticCriteriaForNMO.vue